import { IContentSource } from "../../../../base/domain/drawing";
import { AbstractSource } from "../../../../base/infrastructure/drawing";

export class EditableFormatCacheSource extends AbstractSource {
  constructor(getToken: () => string, public cacheKey: string) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/format-editor/temporary/pdf/" + this.cacheKey + "?token=" + this.token;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): IContentSource {
    return new EditableFormatCacheSource(
      this._getToken,
      this.cacheKey,
    );
  }
}
